import { AppProvider, createRoot } from '@pixi/react'
import { App } from './components/App'
import { apiClient, app, createPixiApp, errorInterceptor, initLanguage, recentRefNoMiddleware } from '@slot-nx/core'
import { gameConfig } from './config'
import gsap from 'gsap'

const urlParams = new URLSearchParams(window.location.search)

gsap.defaults({
  ease: 'none',
})

apiClient.interceptors.response.use((response) => {
  recentRefNoMiddleware(response)
  return response
}, errorInterceptor)
createPixiApp(gameConfig.resolution.width, gameConfig.resolution.height)

initLanguage(urlParams.get('lang'), true, ['EN', 'TH_TH', 'JA_JP', 'ZH_TW']).then(() => {
  createRoot(app.stage).render(
    <AppProvider value={app}>
      <App />
    </AppProvider>,
  )
})
